<template>
  <div class="exhibitSwiper">
<!--    <div class="swiper-container">-->
<!--      <div class="swiper-wrapper">-->
<!--        <div class="swiper-slide" @click="ditile(item)" v-for="(item,index) in listData" :key="index">-->
<!--          <div :style="{height: 500 + ((index * 7) - 100) + 'px'}">-->
<!--          <img  :src="item.coverImage"></div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="swiper-box">-->
<!--      <img src="../../../assets/boxBottom.png" alt="">-->
<!--      <p>{{listBottomData.name}}</p>-->
<!--      <p>{{listBottomData.address}}</p>-->
<!--      <p>{{listBottomData.createTime}} ~ {{listBottomData.endDateTime}}</p>-->
<!--    </div>-->
    <img class="topImg" @click.stop="ditiles(bigImg)" :src="bigImg.coverBigImage" alt="">
    <div class="swiper-bottom">
      <div>
        <img src="@/assets/dizhi@2x.png" alt=""><span>{{bigImg.address}}</span>
      </div>
      <div>
        <img src="@/assets/shijian@2x.png" alt=""><span>{{bigImg.startDateTime}} ~ {{bigImg.endDateTime}}</span>
      </div>
      <img class="niaozunImg" src="@/assets/niaozun.png" alt="">
      <div class="bottom-img">
        <div v-for="(item,index) in listData" :key="index">
          <img @click="ditile(item)" :src="item.coverImage" alt="">
          <div>{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/swiper-bundle.css'
import { getExhibitionList } from '@/api/exhibit'
export default {
  name: 'index.vue',
  data () {
    return {
      listData: [],
      listBottomData: '',
      bigImg: {}
    }
  },
  mounted () {
    setTimeout(() => {
      this.initSwiper()
    }, 300)
    this.list()
  },
  methods: {
    async list () {
      const { result } = await getExhibitionList()
      console.log(result.records)
      this.listData = result.records
      this.bigImg = result.records[0]
      this.listBottomData = this.listData[0]
    },
    initSwiper () {
      var that = this
      this.swiper = new Swiper('.swiper-container', {
        watchSlidesProgress: true, // 查看slide的progress
        resistanceRatio: 0, // 禁止边缘移动
        speed: 1000,
        on: {
          init: function () {
            const slides = this.slides
            for (let i = 0; i < slides.length; i++) {
              const slide = slides.eq(i)
              slide.css('zIndex', 100 - i) // 设置slide的z-index层级
            }
          },
          slideChangeTransitionStart: function () {
            that.listBottomData = that.listData[this.activeIndex]
            console.log(this.activeIndex) // 切换结束时，告诉我现在是第几个slide
          },

          resize: function (swiper) {
            swiper.update()
          },

          setTranslate: function () {
            const slides = this.slides
            // const height = this.height / 7 // 每个slide的位移值
            const offsetAfter = this.width * 0.95 // 每个slide的位移值
            for (let i = 0; i < slides.length; i++) {
              const slide = slides.eq(i)
              const progress = slides[i].progress

              if (progress <= 0) { // 右边slide位移
                slide.transform('translate3d(' + (progress) * offsetAfter + 'px, ' + progress * -10 + 'px, 0) scale(' + (1 - Math.abs(progress) / 20) + ')')
                slide.css('opacity', (progress + 3)) // 最右边slide透明
              }

              if (progress > 0) {
                slide.transform('rotate(' + (-progress) * 5 + 'deg)') // 左边slide旋转
                slide.css('opacity', 1 - progress) // 左边slide透明
              }
            }
          },
          setTransition: function (swiper, transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              slide.transition(transition)
            }
          }
        }
      })
    },
    ditile (item) {
      console.log(item)
      this.bigImg = item
    },
    ditiles (item) {
      console.log(item)
      this.$router.push(`/exhibitSwiperDitile/${item.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar{
  display:none;
}
.exhibitSwiper {
  position:relative;
  overflow: hidden;
  height: 100vh;
  .topImg {
    width: 100%;
    height: 100vh;
    //object-fit: cover;
  }
  .swiper-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 320px;
    background-image: url('../../../assets/sweiper-di@3x.png');
    background-size: 100% 100%;
    padding-top: 110px;
    box-sizing: border-box;
    overflow: hidden;
    .niaozunImg {
      position: absolute;
      width: 60%;
      height: 70%;
      object-fit: cover;
      right: 0;
      bottom: 0;
      z-index: 0;
    }
    .bottom-img {
      position: relative;
      white-space: nowrap;
      overflow-y: scroll;
      padding-left: 26px;
      >div {
        display:inline-block;
        img {
          width: 140px;
          height: 100px;
          border-radius: 10px;
          display: inline-block;
          object-fit: cover;
        }
        div {
          width: 140px;
          box-sizing: border-box;
          padding-right: 0;
          text-align: center;
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          font-family: 'PingFangMedium';
          margin-top: 6px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
      }
    }
    >div {
      padding-left: 59px;
      box-sizing: border-box;
      margin-bottom: 9px;
      &:nth-of-type(2) {
        margin-bottom: 25px;
      }
      img {
        width: 14px;
        vertical-align: middle;
        margin-right: 12px;
      }
      span {
        font-family: 'PingFangMedium';
        font-size: 14px;
        color: #7E532C;
      }
    }
  }
  .swiper-container {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 36px;
    overflow: initial;
  }
  .swiper-box {
    position: relative;
    width: 90%;
    height: 112px;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
    p {
      position: relative;
      &:nth-child(2) {
        font-size: 16px;
        font-weight: bold;
        color: #FFFFFF;
        margin-bottom: 10px;
        margin-top: 20px;
      }
      &:nth-child(3),
      &:nth-child(4) {
        font-size: 13px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
        margin-bottom: 6px;
      }
    }
  }
  .swiper-slide {
    text-align: center;
  }
  .swiper-slide div{
    width:86%;
    height: 400px;
    border-radius:7px;
    margin:10px 0 10px 4%;
    box-sizing: border-box;
  }
  .swiper-slide div img{
    width:100%;
    height: 100%;
    object-fit:cover;
    display:block;
    border-radius:13px;
    box-shadow: 0px 0px 20px 0px rgba(000, 000, 000, 0.3);
  }
}

</style>
